import { Menu, MenuButton, MenuList } from "../Menu";
import type { PackCategory } from "./PackCategory";
import { PackCategoryLabel } from "./PackCategoryLabel";

export const PackCategoryMenu: React.FC<{
  children: React.ReactElement;
  category?: PackCategory;
}> = ({ children, category }) => {
  return (
    <Menu placement="start">
      <MenuButton className="btn btn-outline max-md:btn-sm">
        {category ? (
          <PackCategoryLabel category={category} />
        ) : (
          "Filter by category"
        )}
      </MenuButton>
      <MenuList>{children}</MenuList>
    </Menu>
  );
};
